<template>
  <div  v-click-outside.capture="onClickOutside"
  v-click-outside:mousedown.capture="onClickOutside"
  v-click-outside:touchstart.capture="onClickOutside"
    :class="[
      'product-input',
      'search-input-item',
      { active: isActive, error: hasError },
      styleName
    ]"
    @click.stop.prevent
    @keyup.tab="$parent.tabEvent($event, 'pr')"
    @keyup.enter="$parent.enterEvent($event, 'pr')"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
  >
    <div class="wrap" @click.prevent="inputClick">
      <div class="title">
        <span>{{placeholderText}}</span>
      </div>
      <div class="value">
        <transition
          mode="out-in"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
        >
          <div class="placeholder" key="placeholder" v-if="!isShowInput">
            {{
              (defaultPlaceholder && defaultPlaceholder.code) ||
              "输入" + placeholderText ||
                "输入商品编码/名称"
            }}
          </div>
          <input
            type="text"
            class="input"
            ref="input"
            key="input"
            @blur="blur"
            contenteditable="true"
            v-else
            v-model.trim="text"
            @input="inputEvent"
            @focus="isShowDropDown=true"
          />
        </transition>
      </div>

      <!-- <transition @enter="clearEnter" @leave="clearLeave">
        <img src="@/assets/images/icons/search/clear.png" class="clear" @click.prevent="clearContentHandle" v-show="isShowClear" v-if="text">
        <svg-icon icon-class="arrow" class="arraw" v-else></svg-icon>
      </transition>

      <transition @before-enter="divideBeforeEenter" @enter="divideEnter" @leave="divideLeave">
        <div class="divide" v-show="isShowDropDown"></div>
      </transition> -->
    </div>

    <transition
      @enter="dropdownEnter"
      @after-enter="afterDropdownEnter"

      @leave="dropdownLeave"
    >
      <Dropdown
        v-show="isShowDropDown"
        :value="text"
        :countrycode="countrycode"
        @selectItem="selectItem"

        :dropDownHeight="dropDownHeight"
        ref="dropdownComponent"
      ></Dropdown>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import Velocity from "velocity-animate";
// eslint-disable-next-line
import VelocityUI from "velocity-animate/velocity.ui";
import Dropdown from "./ProductDropdown";
import { createNamespacedHelpers } from "vuex";
const { mapState: mapDataState } = createNamespacedHelpers("data");
const { mapState: mapSearchState } = createNamespacedHelpers("search");
const {
  mapState: mapProductState,
  mapGetters: mapProductGetters,
  mapMutations: mapProductMutations
} = createNamespacedHelpers("search/product");

export default {
  name: "Product",
  props: {
    countrycode: {
      type: [Number, String],
      default: 27
    },
    currentState: {
      type: String,
      default: "rate",
      required: true,
      validator: function(value) {
        return (
          Vue._.indexOf(
            ["rate", "rules", "hscode", "rulesdecide", "enjoy"],
            value
          ) !== -1
        );
      }
    },
    noFoundMsg: String,
    placeholderText: String,
    styleName: {
      type: String,
      default: "n",
      required: false
    }
  },
  data() {
    return {
      isActive: false,
      hasError: false,
      isShowInput: false,
      isShowClear: false,
      isShowDropDown: false,
      allowShowDropDown: true,
      isdefaultValue: false,
      text: "",
      productName: "",
      dropDownHeight: {}
    };
  },
  components: { Dropdown },
  computed: {
    value: {
      get() {
        if (this.currentState === "rate") {
          return this.getRateValue();
        } else if (this.currentState === "rules") {
          return this.getRulesValue();
        } else {
          return this.getHsCodeValue();
        }
      },
      set(v) {
        if (this.currentState === "rate") {
          this.setRateValue(v);
        } else if (this.currentState === "rules") {
       
          this.setRulesValue(v);
        } else {
          this.setHsCodeValue(v);
        }
      }
    },
    defaultPlaceholder() {
      return {};
    },
    // ...mapDataState({
    //   defaultPlaceholder: state => state.productPlaceholder
    // }),
    ...mapSearchState({
      lastHistory: state => state.history.all && state.history.all[0]
    }),
    ...mapProductState({
      clearInputText: state => state.clear
    })
  },

  watch: {
    value(newVal, oldVal) {
    
      if (newVal.id && (newVal.id || "") !== (this.text || "")) {
        this.allowShowDropDown = false;
        this.text = newVal.id;
        this.isShowInput = !this._.isEmpty(this.text);
      }
    },
    clearInputText(newVal, oldVal) {
      this.text = "";
      this.isShowClear = false;
      this.isShowInput = false;
      this.isActive = false;
    },
    text:{
      handler(newVal, oldVal) {
      //   debugger
      //   if (newVal) {
      //   if (this.isdefaultValue) {
      //     this.isShowDropDown = false;
      //   } else {
      //     this.isShowDropDown = true;
      //   }
      // } else {
      //   this.isShowDropDown = false;
      //   this.isdefaultValue = false;
      // }
 
      this.$emit("onInput", newVal);
      },
      deep: true
    
 
     
    }
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      this.$root.$on("appClicker", function(event) {
        vm.isShowDropDown = false;
      });
      // if (!this.value.id && !this._.isEmpty(this.lastHistory) && !this._.isEmpty(this.lastHistory.products)) {
      //   this.setDefaultValue(this.lastHistory.products)
      // }
      let minHeight = 200;
      let maxHeight = 200;
      if (this.$parent.$options.name === "QuickSearch") {
        maxHeight = 300;
      } else {
        maxHeight =
          this._h.getWinHeight() -
          (this._h.getScrollTop() + this._h.getOffset(this.$el).bottom) -
          50;
        if (maxHeight > 300) maxHeight = 300;
      }
      maxHeight = this._.max([minHeight, maxHeight]);
      this.dropDownHeight = {
        minHeight: minHeight,
        height: maxHeight,
        maxHeight: maxHeight
      };
    });
  },
  methods: {
    onClickOutside(event) {
        this.isShowDropDown = false
    },
    setDefaultValue(v, t = false) {
   
  
      if (this._.isString(v)) {
        let res = this.$refs.dropdownComponent.getIsLastProductByCode()(v);
        if (res) {
          this.allowShowDropDown = false;
          this.isShowInput = true;
          this.selectItem(
            this._.trim(res.code),
            this._.trim(res.name),
            res._level,
            true,
            true
          );
        }
      } else {
        this.allowShowDropDown = false;
        this.isShowInput = true;
        this.value = {
          id: this._.trim(v.id),
          text: this._.trim(v.text),
          _level: v._level
        };
        this.text = this.value.id;
        this.isdefaultValue = t;
      }
    },
    setValueFromDefaultPlaceholder() {
      if (
        (!this.text || !this.value.id) &&
        !this._.isEmpty(this.defaultPlaceholder)
      ) {
        this.value = {
          id: this._.trim(this.defaultPlaceholder.code),
          text: this._.trim(this.defaultPlaceholder.name),
          _level: this.defaultPlaceholder._level
        };
        this.text = this.value.id;
      }
    },
    inputClick(event) {
      if ((!this.value || !this.value.id) && !this.isShowInput) {
        this.text = "";
      }
      this.$emit("handleClick", event, "product");
      // if (this.isShowInput) {
        
      //   this.isShowDropDown = true;
      // }
      // if (this.text === "") {
      //   this.isShowDropDown = false;
      // }
      this.isShowDropDown = true;
      this.allowShowDropDown = true;
      this.isShowInput = true;
      this.isActive = true;
      this.isShowClear = false;
    },
    clearContent(isShowInputText = true) {
      this.isShowClear = false;
      this.isShowInput = isShowInputText;
      this.isActive = isShowInputText;
      this.value = "";
      this.text = "";
    },
    clearContentHandle() {
      this.clearContent();
      this.$refs.input && this.$refs.input.focus();
    },
    resetContent(isShowDP = false) {
      if (isShowDP) {
        this.isShowInput = false;
        setTimeout(() => {
          this.allowShowDropDown = true;
          this.clearContent();
        }, 100);
      } else {
        this.clearContent(false);
      }
    },
    blur() {
      this.setDefaultValue({ id: this.text }, true);
      if (!this.checkInputContent()) {
        this.clearContent();
      }
    },
    closeDowndown(isBlur, event) {
      if (isBlur && this.$refs.input) this.$refs.input.blur();
      this.isShowDropDown = false;
      if (isBlur === undefined) {
        this.$emit("closeDropdown", event, "pr");
      }
    },
    selectItem(
      id,
      name,
      _level,
      isLastItem,
      isDefault = false,
      event = window.event
    ) {
      if (this.$refs.dropdownComponent) {
        this.$refs.dropdownComponent.isAllowUpdateData = false;
      }
      if (isLastItem) {
        this.value = {
          id: this._.trim(id),
          text: this._.trim(name),
          _level: _level
        };
        this.text = this.value.id;
        this.productName = name;
        this.isShowDropDown = false;
        this.isActive = false;
        if (!isDefault && this.value.id) {
          setTimeout(() => {
            this.$emit("closeDropdown", event, "pr");
          }, 200);
        }
      } else {
        if (this.$options.filters.isSpecialHSCode(this._.trim(id))) {
        } else {
          this.text = this._.trim(id);
        }
        this.productName = name;
      }
    },
    checkInputContent(type = 1) {
      if (type === 1) {
        return this._.trim(this.text) !== "";
      } else if (type === 2) {
        return this._.trim(this.text) !== "" && this.value.id;
      } else if (type === 3) {
        return this._.trim(this.text) !== "" && !this.value.id;
      }
    },
    mouseEnter() {
      if (!this.isShowDropDown && this.checkInputContent()) {
        this.isShowClear = true;
      }
    },
    mouseLeave() {
      this.isShowClear = false;
    },
    clearEnter(el, done) {
      this.text &&
        Velocity(el, { rotateZ: 90 }, { duration: 100, complete: done });
    },
    clearLeave(el, done) {
      this.text &&
        Velocity(el, { rotateZ: 0 }, { duration: 100, complete: done });
    },
    inputEvent(event) {
      this.isShowDropDown = true;
      this.value = "";
    },
    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20px)";
    },
    enter(el, done) {
      Velocity(
        el,
        { opacity: 1, translateY: "0px" },
        { duration: 100, complete: done }
      );
    },
    afterEnter(el) {
      if (this.isShowInput) {
        this.$nextTick(() => {
          if (this.allowShowDropDown) {
            this.$refs.input.focus();
            if (!this.isShowDropDown) {
          
              this.isShowDropDown = true;
            }
          } else {
            this.allowShowDropDown = true;
          }
        });
      }
    },
    beforeLeave(el) {
      el.style.transform = "translateY(0px)";
    },
    leave(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "-20px" },
        { duration: 100, complete: done }
      );
    },
    divideBeforeEenter(el) {
      el.style.opacity = 0.1;
    },
    divideEnter(el, done) {
      Velocity(
        el,
        { width: "100%", opacity: 1 },
        { duration: 200, complete: done }
      );
    },
    divideLeave(el, done) {
      Velocity(
        el,
        { width: "0%", opacity: 0.1 },
        { duration: 200, complete: done }
      );
    },
    dropdownEnter(el, done) {
      if (this.value.id) {
        this.$refs.dropdownComponent.getProductList(this.value.id || this.text);
      }
      this.$refs.dropdownComponent.updateContentHeight();
      Velocity(el, "transition.slideDownIn", { duration: 150, complete: done });
    },
    afterDropdownEnter(el) {
      this.$refs.dropdownComponent.refresh();
      this.$refs.dropdownComponent.scrollToTop();
      this.$parent.handleClick && this.$parent.handleClick(null, "product");
    },
    beforeDropdownLeave(el) {
      if (this.text === "") {
        this.value = "";
      } else if (this.checkInputContent(3)) {
        let res = this.$refs.dropdownComponent.getIsLastProductByCode()(
          this.text
        );
        if (res) {
          this.selectItem(res.code, res.name, res._level, true);
        } else {
          // this.hasError = true
    
          this.$Message.warning({
         
            content: this.noFoundMsg || this.$t("query.message.product_error"),
            closable: true
          });
        }
      }
      if (this.checkInputContent()) {
        if (this.$refs.input) this.$refs.input.blur();
      } else {
        this.isShowInput = false;
      }
      this.isActive = false;
    },
    dropdownLeave(el, done) {
      Velocity(el, "transition.slideUpOut", { duration: 150, complete: done });
    },
    ...mapProductGetters(["getRateValue", "getRulesValue", "getHsCodeValue"]),
    ...mapProductMutations(["setRateValue", "setRulesValue", "setHsCodeValue"])
  }
};
</script>
<style scoped>
.search-input-item {
  /* border: 1px solid #ddd; */
  /*font-size: 11px;*/
  /*float: left;*/
  position: relative;
  background-color: #fff;
}
.search-input-item .wrap {
  padding: 3px 25px 3px 6px;
}
.search-input-item .title {
  color: #0774b5;
  font-weight: bold;
  /*font-size: 10px;*/
  font-size: 15px;
  background: url("~@/assets/images/home/pro.png") 0 6px no-repeat transparent;
  padding-left: 18px;
  background-size: 12px;
  margin-bottom: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-input-item.active .title {
  /* background-image: url("~@/assets/images/icons/search/product_active.png"); */
  /* color: #0774b5; */
}
.search-input-item.error {
  border-color: #f9b5b5;
}
.search-input-item .value {
  color: #333;
  /* padding-left: 11px; */
  /*font-size: 1.1rem;*/
  border: 1px solid #0774b5;
  /* margin-top: 10px; */
}
.search-input-item .value .input {
  outline: 0 none;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  width: 100%;
  border: 0 none;
  font-size: 1.6rem;
  height: 30px;
  line-height: 30px;
  padding: 3px 5px;
  box-sizing: border-box;
}
.search-input-item .value .placeholder {
  color: #8b8989;
  /*font-size: 1.1rem;*/
  font-size: 1.6rem;
  outline: 0 none;
  cursor: text;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  box-sizing: border-box;
}
.search-input-item.s .title {
  position: absolute;
  width: 11px;
  height: 13px;
  background-position-y: 2px;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  font-size: 0;
}
.search-input-item.s .title span {
  display: none;
}
.search-input-item.s .value {
  padding-left: 15px;
  height: 22px;
  line-height: 22px;
}
.clear,
.arraw {
  position: absolute;
  top: 50%;
  width: 10px;
  height: 10px;
  margin-top: -5px;
  right: 9px;
  cursor: pointer;
}
.arraw {
  color: #b5b2b2;
  transition: all 0.3s;
}
.active .arraw {
  color: #2681ff;
  transform: rotate(180deg);
}
.search-input-item:hover .arraw {
  color: #2681ff;
}
.divide {
  background-color: #2681ff;
  position: absolute;
  left: 0;
  top: 100%;
  height: 0.5px;
  width: 0%;
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Product.vue